import { render, staticRenderFns } from "./banManage.vue?vue&type=template&id=48a42e66"
import script from "./banManage.vue?vue&type=script&lang=js"
export * from "./banManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports